import type { GroupWithQueues } from '@atlassian/jira-router-resources-service-desk-queues/src/types.tsx';
import { QueueListSection } from '@atlassian/jira-servicedesk-queues-categorized-store/src/controllers/navigation-category/index.tsx';
import type { QueueNavItem } from '../../../../types/index.tsx';

export const calculateSelectedSection = (
	queue: QueueNavItem,
	priorityGroups: GroupWithQueues[],
	lastSelectedSection: QueueListSection | undefined,
	currentSection: QueueListSection,
	selectedGroupId?: string,
) => {
	if (currentSection === lastSelectedSection) {
		return currentSection;
	}
	const isStarred = queue.starred;
	const selectedPriorityGroup = priorityGroups.find((group) => group.id === selectedGroupId);
	const isQueueInSelectedGroup = selectedPriorityGroup?.queues.some(
		(queueInGroup) => queueInGroup.toString(10) === queue.id,
	);

	if (lastSelectedSection === QueueListSection.STARRED && !queue.starred) {
		return isQueueInSelectedGroup ? QueueListSection.PRIORITY_GROUP : QueueListSection.ALL_QUEUES;
	}

	if (lastSelectedSection === QueueListSection.PRIORITY_GROUP && !isQueueInSelectedGroup) {
		return isStarred ? QueueListSection.STARRED : QueueListSection.ALL_QUEUES;
	}

	if (lastSelectedSection === undefined) {
		if (isStarred) {
			return QueueListSection.STARRED;
		}
		if (isQueueInSelectedGroup) {
			return QueueListSection.PRIORITY_GROUP;
		}
		return QueueListSection.ALL_QUEUES;
	}
	return lastSelectedSection;
};
